"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var Client_1 = require("./Client");
var Search_1 = require("./Search");
exports.defaultState = {
  autoComplete: null,
  autoFocus: false,
  page: 0,
  pages: [],
  search: "",
  searching: false,
  suggestions: []
};
var searchDelay = 250;
var keyCodes = {
  Tab: 9,
  ArrowLeft: 37,
  ArrowRight: 39
};
var Tenor = /** @class */function (_super) {
  __extends(Tenor, _super);
  function Tenor(props) {
    var _this = _super.call(this, props) || this;
    _this.fetchAutoComplete = function (currentSearch) {
      return _this.client.autocomplete(currentSearch).then(function (_a) {
        var autoComplete = _a.results[0];
        var search = _this.state.search;
        if (search === currentSearch) {
          _this.mountedSetState({
            autoComplete: autoComplete
          });
        }
      });
    };
    _this.fetchSuggestions = function (currentSearch) {
      return _this.client.suggestions(currentSearch).then(function (_a) {
        var suggestions = _a.results;
        var search = _this.state.search;
        if (search === currentSearch) {
          _this.mountedSetState({
            suggestions: suggestions
          });
        }
      });
    };
    _this.handleWindowClick = function (event) {
      var contentRef = _this.props.contentRef;
      var search = _this.state.search;
      if (!search) {
        return;
      }
      var container = (contentRef || _this.contentRef).current;
      if (container && event.target instanceof Element && container.contains(event.target)) {
        return;
      }
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      _this.setState(exports.defaultState);
    };
    _this.handleWindowKeyDown = function (event) {
      var contentRef = _this.props.contentRef;
      var container = (contentRef || _this.contentRef).current;
      if (container && event.target instanceof Element && !container.contains(event.target) || [keyCodes.ArrowLeft, keyCodes.ArrowRight].indexOf(event.keyCode) === -1 || !event.metaKey) {
        return;
      }
      event.preventDefault();
      if (event.keyCode === keyCodes.ArrowLeft) {
        _this.handlePageLeft();
      } else {
        _this.handlePageRight();
      }
    };
    _this.handlePageLeft = function () {
      _this.setState(function (_a) {
        var page = _a.page;
        return {
          page: page === 0 ? 0 : page - 1
        };
      });
    };
    _this.handlePageRight = function () {
      var defaultResults = _this.props.defaultResults;
      var _a = _this.state,
        page = _a.page,
        pages = _a.pages,
        search = _a.search,
        searching = _a.searching;
      if (!defaultResults && !search || searching) {
        return Promise.resolve();
      }
      if (page < pages.length - 1) {
        _this.setState(function (_a) {
          var prevPage = _a.page;
          return {
            page: prevPage + 1
          };
        });
        return Promise.resolve();
      }
      return _this.client.search(search, pages[page].next).then(function (nextPage) {
        if (nextPage.results) {
          _this.mountedSetState(function (_a) {
            var prevPage = _a.page,
              prevPages = _a.pages;
            return {
              page: prevPage + 1,
              pages: prevPages.concat([nextPage]),
              searching: false
            };
          });
        }
      }).catch(function () {
        _this.mountedSetState({
          searching: false
        });
      });
    };
    _this.handleSearchChange = function (event) {
      var defaultResults = _this.props.defaultResults;
      var search = event.target.value;
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      if (!search.length) {
        if (defaultResults) {
          _this.setState(__assign(__assign({}, exports.defaultState), {
            searching: true
          }));
          _this.performSearch(search);
        } else {
          _this.setState(exports.defaultState);
        }
        return;
      }
      _this.setState({
        autoComplete: null,
        search: search,
        searching: true
      });
      _this.fetchAutoComplete(search);
      _this.fetchSuggestions(search);
      _this.timeout = setTimeout(function () {
        return _this.performSearch(search);
      }, searchDelay);
    };
    _this.handleSearchKeyDown = function (event) {
      var _a = _this.state,
        autoComplete = _a.autoComplete,
        prevSearch = _a.search;
      if (event.keyCode !== keyCodes.Tab || !autoComplete || !prevSearch) {
        return;
      }
      var lowerAutoComplete = autoComplete.toLowerCase();
      var lowerSearch = prevSearch.toLowerCase().replace(/\s/g, "");
      if (lowerAutoComplete === lowerSearch) {
        return;
      }
      event.preventDefault();
      var typeahead = lowerAutoComplete.replace(lowerSearch, "");
      var search = "" + prevSearch + typeahead;
      _this.setState({
        autoComplete: null,
        search: search,
        searching: true
      });
      _this.fetchSuggestions(search);
      _this.performSearch(search);
    };
    _this.handleSuggestionClick = function (suggestion) {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      _this.setState({
        search: suggestion,
        searching: true
      });
      _this.performSearch(suggestion);
    };
    _this.performSearch = function (search) {
      if (!_this.componentIsMounted) {
        return Promise.resolve();
      }
      return _this.client.search(search).then(function (page) {
        _this.mountedSetState({
          page: 0,
          pages: [page],
          searching: false
        });
      }).catch(function () {
        _this.mountedSetState({
          searching: false
        });
      });
    };
    _this.mountedSetState = function (state) {
      if (_this.componentIsMounted) {
        _this.setState(state);
      }
    };
    _this.client = _this.makeClient();
    _this.contentRef = React.createRef();
    _this.inputRef = React.createRef();
    _this.timeout = null;
    _this.componentIsMounted = false;
    _this.state = __assign(__assign({}, exports.defaultState), {
      search: props.initialSearch || "",
      searching: !!(props.initialSearch || props.defaultResults)
    });
    return _this;
  }
  Tenor.prototype.componentDidMount = function () {
    var _a = this.props,
      autoFocus = _a.autoFocus,
      initialSearch = _a.initialSearch,
      defaultResults = _a.defaultResults;
    this.componentIsMounted = true;
    window.addEventListener("keydown", this.handleWindowKeyDown);
    window.addEventListener("click", this.handleWindowClick);
    if (initialSearch) {
      this.fetchAutoComplete(initialSearch);
      this.fetchSuggestions(initialSearch);
    }
    if (initialSearch || defaultResults) {
      this.performSearch(initialSearch || "");
    }
    if (autoFocus) {
      this.focus();
    }
  };
  Tenor.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
      base = _a.base,
      token = _a.token,
      locale = _a.locale,
      mediaFilter = _a.mediaFilter,
      contentFilter = _a.contentFilter,
      defaultResults = _a.defaultResults,
      limit = _a.limit;
    if (base !== prevProps.base || token !== prevProps.token || locale !== prevProps.locale || mediaFilter !== prevProps.mediaFilter || contentFilter !== prevProps.contentFilter || defaultResults !== prevProps.defaultResults || limit !== prevProps.limit) {
      this.client = this.makeClient();
    }
  };
  Tenor.prototype.componentWillUnmount = function () {
    window.removeEventListener("click", this.handleWindowClick);
    window.removeEventListener("keydown", this.handleWindowKeyDown);
    this.componentIsMounted = false;
  };
  Tenor.prototype.makeClient = function () {
    var _a = this.props,
      base = _a.base,
      token = _a.token,
      locale = _a.locale,
      mediaFilter = _a.mediaFilter,
      contentFilter = _a.contentFilter,
      defaultResults = _a.defaultResults,
      limit = _a.limit;
    return new Client_1.default({
      base: base,
      token: token,
      locale: locale,
      mediaFilter: mediaFilter,
      contentFilter: contentFilter,
      defaultResults: defaultResults,
      limit: limit
    });
  };
  Tenor.prototype.focus = function () {
    var input = this.inputRef.current;
    if (input) {
      input.focus();
    }
  };
  Tenor.prototype.render = function () {
    var _a = this.props,
      contentRef = _a.contentRef,
      onSelect = _a.onSelect,
      searchPlaceholder = _a.searchPlaceholder;
    var _b = this.state,
      autoComplete = _b.autoComplete,
      page = _b.page,
      pages = _b.pages,
      search = _b.search,
      searching = _b.searching,
      suggestions = _b.suggestions;
    return React.createElement(Search_1.default, {
      autoComplete: autoComplete,
      contentRef: contentRef || this.contentRef,
      inputRef: this.inputRef,
      onPageLeft: this.handlePageLeft,
      onPageRight: this.handlePageRight,
      onSearchChange: this.handleSearchChange,
      onSearchKeyDown: this.handleSearchKeyDown,
      onSuggestionClick: this.handleSuggestionClick,
      onSelect: onSelect,
      results: pages[page] ? pages[page].results : [],
      search: search,
      searching: searching,
      suggestions: suggestions,
      placeholder: searchPlaceholder
    });
  };
  return Tenor;
}(React.Component);
exports.default = Tenor;